var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Suspense } from 'react';
import { useResource } from 'rest-hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useGlue } from "../../core";
import { RenderContent } from "../../block";
import { AxiosErrorBoundary, PublicFormResource } from "../../core/api";
import { CircularProgress } from "@material-ui/core";
const Form = React.forwardRef(({ slug, enableToast, beforeForm, className = '', children }, ref) => {
    const formResource = useResource(PublicFormResource.detail(), { slug: slug });
    const glue = useGlue();
    const form = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
    });
    const submit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        let fieldsData = {};
        const submitData = new FormData();
        for (const pair of Object.entries(data)) {
            if (pair[1] instanceof FileList) {
                if (pair[1].length === 1 && pair[1][0] instanceof File) {
                    submitData.append('file', pair[1][0]);
                    fieldsData[pair[0]] = { reference: 'urn:formfile:' + pair[1][0].name };
                }
                else {
                    console.error('Erreur dans le traitement des input file');
                }
            }
            else {
                fieldsData[pair[0]] = { value: pair[1] };
            }
        }
        //Make glue Smartforms send
        submitData.append('fields', JSON.stringify(fieldsData));
        try {
            yield glue.api.post('/api/forms/submit/' + slug, submitData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (enableToast) {
                toast.success('Formulaire bien envoyé.');
            }
            Object.keys(data).forEach((key) => {
                if (data[key] instanceof Array)
                    data[key] = [];
                else
                    data[key] = '';
            });
            form.reset(Object.assign({}, data), { keepValues: false, keepIsSubmitted: true, keepSubmitCount: true });
        }
        catch (e) {
            if (enableToast) {
                toast.error("Erreur lors de l'envoi au serveur.");
            }
        }
    });
    return (React.createElement(FormProvider, Object.assign({}, form),
        React.createElement("form", { ref: ref, className: className, onSubmit: form.handleSubmit(submit) },
            beforeForm,
            React.createElement(RenderContent, { content: formResource.content.value }),
            children)));
});
export const RenderHookForm = React.forwardRef(({ slug, className = '', suspenseFallback = React.createElement(CircularProgress, null), children, beforeForm, enableToast = true, }, ref) => {
    return (React.createElement(Suspense, { fallback: suspenseFallback },
        React.createElement(AxiosErrorBoundary, null,
            React.createElement(Form, { ref: ref, slug: slug, className: className, beforeForm: beforeForm, enableToast: enableToast }, children))));
});
//# sourceMappingURL=RenderHookForm.js.map